var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "#888b8d",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 4.5C9.476 4.5 8.5 5.476 8.5 6.667v18.667c0 1.191.976 2.167 2.167 2.167h10.667c1.191 0 2.167-.976 2.167-2.167V6.667c0-1.191-.976-2.167-2.167-2.167H10.667zM7.5 6.667C7.5 4.924 8.924 3.5 10.667 3.5h10.667c1.743 0 3.167 1.424 3.167 3.167v18.667c0 1.743-1.424 3.167-3.167 3.167H10.667c-1.743 0-3.167-1.424-3.167-3.167V6.667zm7.733 16.799c0-.4.233-.9.767-.9.246 0 .432.125.553.246s.215.273.294.43a.5.5 0 0 1 .053.224c0 .229-.11.417-.23.537s-.308.23-.537.23c-.4 0-.9-.233-.9-.767zM13.767 8a.5.5 0 0 1 .5-.5H17.6a.5.5 0 1 1 0 1h-3.333a.5.5 0 0 1-.5-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.ec6d37469304e0f3b11004f333c3d533.svg";
export { ForwardRef as ReactComponent };